import SEO from "../../../shared/components/SEO";
import InternalSubcategoryTemplate from "../internal-subcategory-template/InternalSubcategoryTemplate";
import Layout from "../layout/layout";

const InternalTemplate = ({ pageContext }: any) => {
  return (
    <Layout>
      <SEO
        title={pageContext.dataSEO?.metaTitle}
        description={pageContext.dataSEO?.metaDescription}
        index={pageContext.dataSEO?.index}
        urlCanonical={pageContext.dataSEO?.urlCanonical}
        ogImage={pageContext.dataSEO?.metaImage?.file?.url}
        slug={pageContext.dataSEO?.slug}
      />
      <InternalSubcategoryTemplate />
    </Layout>
  );
};

export default InternalTemplate;
